<script setup>
import { inject, onMounted, ref } from 'vue';

const props = defineProps({
  position: {
    type: String,
    default: 'bottom-right',
  },
  showZoom: {
    type: Boolean,
    default: true,
  },
  showCompass: {
    type: Boolean,
    default: false,
  },
  showLocate: {
    type: Boolean,
    default: false,
  },
  showFullscreen: {
    type: Boolean,
    default: false,
  },
});

const { map } = inject('mapContext');

const handleZoomIn = () => map.value?.zoomIn();
const handleZoomOut = () => map.value?.zoomOut();
const handleLocate = () => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(pos => {
      map.value?.flyTo({
        center: [pos.coords.longitude, pos.coords.latitude],
        zoom: 14,
      });
    });
  }
};
const handleFullscreen = () => {
  const container = map.value?.getContainer();
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    container?.requestFullscreen();
  }
};

const positionClasses = {
  'top-left': 'top-4 left-4',
  'top-right': 'top-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-right': 'bottom-4 right-4',
};
</script>

<template>
  <div
    class="absolute z-10 flex flex-col gap-2"
    :class="[positionClasses[position]]"
  >
    <div
      v-if="showZoom"
      class="flex flex-col rounded-xl border border-n-weak bg-white/95 dark:bg-n-slate-12/95 backdrop-blur-md shadow-lg overflow-hidden"
    >
      <button
        class="size-10 flex items-center justify-center hover:bg-n-alpha-1 transition-colors border-b border-n-weak"
        @click="handleZoomIn"
      >
        <span class="i-lucide-plus size-5 text-n-slate-11" />
      </button>
      <button
        class="size-10 flex items-center justify-center hover:bg-n-alpha-1 transition-colors"
        @click="handleZoomOut"
      >
        <span class="i-lucide-minus size-5 text-n-slate-11" />
      </button>
    </div>

    <div
      v-if="showLocate"
      class="rounded-xl border border-n-weak bg-white/95 dark:bg-n-slate-12/95 backdrop-blur-md shadow-lg overflow-hidden"
    >
      <button
        class="size-10 flex items-center justify-center hover:bg-n-alpha-1 transition-colors"
        @click="handleLocate"
      >
        <span class="i-lucide-locate size-5 text-n-slate-11" />
      </button>
    </div>

    <div
      v-if="showFullscreen"
      class="rounded-xl border border-n-weak bg-white/95 dark:bg-n-slate-12/95 backdrop-blur-md shadow-lg overflow-hidden"
    >
      <button
        class="size-10 flex items-center justify-center hover:bg-n-alpha-1 transition-colors"
        @click="handleFullscreen"
      >
        <span class="i-lucide-maximize size-5 text-n-slate-11" />
      </button>
    </div>
  </div>
</template>
